import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CrudGenericsService } from '../common/crud-generics';
import { Environment, Postazioni, ModelNumStr, ModelNumStrNav, NgPrintQrModel } from '../../models/-index';

@Injectable()
export class PostazioniService extends CrudGenericsService<Postazioni, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/Postazioni`);
    this.base = `${env.apiUrl}/api/Postazioni/`;
  }

  Get4Select_ByDiv(div: number = 0): Observable<ModelNumStr[]> {
    const u = `${this.base}Get4Select_ByDiv?div=${div}`;
    return this.http.get<ModelNumStr[]>(u);
  }
  Get4Select_ByReparto(rep: number): Observable<ModelNumStr[]> {
    const u = `${this.base}Get4Select_ByReparto?rep=${rep}`;
    return this.http.get<ModelNumStr[]>(u);
  }
  // navigazione / filtro
  Get4Select_RepartoNavigation(): Observable<ModelNumStrNav[]> {
    const u = `${this.base}Get4Select_RepartoNavigation`;
    return this.http.get<ModelNumStrNav[]>(u);
  }
  // print etichetta
  GetNgPrintQrModel(id): Observable<NgPrintQrModel> {
    const u = `${this.base}GetNgPrintQrModel?id=${id}`;
    return this.http.get<NgPrintQrModel>(u);
  }
}
